import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: "/index"
    },
    {
      path: '/index',//首页
      name: 'index',

      component: () => import('@/views/index.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/companyprofile',//公司介绍
      name: 'companyprofile',

      component: () => import('@/views/companyprofile.vue'),
      meta: {
        title: '公司介绍'
      }
    },
    {
      path: '/productcenter',//产品中心
      name: 'productcenter',
      component: () => import('@/views/product/productcenter.vue'),
      meta: {
        title: '产品中心'
      }
    },
    {
      path: '/solution',//解决方案
      name: 'solution',
      component: () => import('@/views/solution.vue'),
      meta: {
        title: '解决方案'
      }
    },
    {
      path: '/newsinfomation',//新闻资讯
      name: 'newsinfomation',
      component: () => import('@/views/news/newsinfomation.vue'),
      meta: {
        title: '新闻资讯'
      }
    },
    {
      path: '/newsdetail',//新闻详情
      name: 'newsdetail',
      component: () => import('@/views/news/newsdetail.vue'),
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: '/productinfo',//了解详情
      name: 'productinfo',
      component: () => import('@/views/product/productinfo.vue'),
      meta: {
        title: '了解详情'
      }
    },
    {
      path: '/customercase',//客户方案详情页
      name: 'customercase',
      component: () => import('@/views/customercase.vue'),
      meta: {
        title: '客户方案详情'
      }
    },
    {
      path: '/moresuccessfulcase',//成功案例更多案例
      name: 'moresuccessfulcase',
      component: () => import('@/views/moresuccessfulcase.vue'),
      meta: {
        title: '更多案例'
      }
    },
    {
      path: '/promanualdown',//下载中心
      name: 'promanualdown',
      component: () => import('@/views/promanualdown.vue'),
      meta: {
        title: '下载中心'
      }
    },
    {
      path: '/systemlistdetails',//易筑云收验货系统
      name: 'systemlistdetails',
      component: () => import('@/views/product/systemlistdetails.vue'),
      meta: {
        title: '系统详情'
      }
    },
    {
      path: '/productdetail',//产品详情
      name: 'productdetail',
      component: () => import('@/views/product/productdetail.vue'),
      meta: {
        title: '产品详情'
      }
    },
    {
      path: '/casedetail',//更多案例详情
      name: 'casedetail',
      component: () => import('@/views/casedetail.vue'),
      meta: {
        title: '案例详情'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js